<!-- This is organization admin vue file -->
<template>
  <div>
    <!-- Table Data -->
    <div>
      <vs-table id="admin-list" class="vs-con-loading__container" stripe :sst="true" maxHeight="800px"
        @change-page="handleChangePage" @sort="handleSort" :total="adminFilteredCount" :max-items="length"
        :data="adminRecords">
        <template slot="header">
          <!-- Per Page Record -->
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (adminFilteredCount && 1)) || 0 }}
                      -
                      {{ adminFilteredCount - page * length > 0 ? page * length : adminFilteredCount }}
                      of {{ adminTotal || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <div
              v-if="checkPermissionSlug(['organization_admin_list'])"
              @click.stop="inviteMember()"
              class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium border border-solid border-primary"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base">Add {{ module_name }}</span>
            </div>
          </div>
        </template>

        <!-- Table Header -->
        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th>Email</vs-th>
          <vs-th>Mobile Number</vs-th>
          <vs-th>Handle Name</vs-th>
          <vs-th v-if="checkPermissionSlug(['organization_admin_revoke'])">Action</vs-th>
        </template>

        <!-- Table Data Display -->
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td class="text-left">
              <span>{{ tr.email || '-' }}</span>
            </vs-td>
            <vs-td class="text-left">
              <span>{{ tr.mobile || '-' }}</span>
            </vs-td>
            <vs-td class="text-left">
              <span>{{ tr.handle_name || '-' }}</span>
            </vs-td>
            <vs-td v-if="checkPermissionSlug(['organization_admin_revoke'])">
              <div class="inline-flex">
                <vx-tooltip v-if="checkPermissionSlug(['organization_admin_revoke'])"
                  :text="`${module_name} Accees Revoke`">
                  <feather-icon @click.stop="revokeAccess(tr._id, `${tr.email}`)" icon="UserXIcon"
                    svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <!-- Custom Pagination -->
      <vs-pagination v-if="adminFilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5"
        class="mt-8"></vs-pagination>
    </div>
    <vs-popup button-accept="false" button-cancel="false" :active.sync="popupActive" :title="`Invite Organization Admin`">
      <div class="vx-row px-5 vs-con-loading__container">
        <div class="vx-col px-0 w-full">
          <!-- Loop through email, mobile, and handle name inputs -->
          <div v-for="(adminUser, index) in form.newAdminUsers" :key="index" class="mt-2 mb-3">
            <label :for="'Email-' + index">Email {{ index + 1 }}</label>
            <div class="flex justify-between flex-wrap">
              <!-- Email Input -->
              <div class="w-full mb-2">
                <vs-input
                  :id="'Email-' + index"
                  class="w-full"
                  v-model="adminUser.email"
                  type="email"
                  v-validate="'required|email'"
                  :name="'Email-' + index"
                  icon="icon icon-mail"
                  icon-pack="feather"
                  placeholder="Please add Email"
                  data-vv-as="Email"
                  @input="debouncedOrgAdminCheck(adminUser, index)"
                />
                <span class="text-danger text-sm" v-show="errors.has('Email-' + index)">
                  {{ errors.first('Email-' + index) }}
                </span>
              </div>

              <!-- Mobile Input -->
              <div class="w-full mb-2">
                <vs-input
                  :id="'Mobile-' + index"
                  class="w-full"
                  v-model="adminUser.mobile_number"
                  type="tel"
                  v-validate="'required|numeric'"
                  :name="'Mobile-' + index"
                  icon="icon icon-smartphone"
                  icon-pack="feather"
                  placeholder="Please add Mobile Number"
                  data-vv-as="Mobile"
                  @input="debouncedOrgAdminCheck(adminUser, index)"
                />
                <span class="text-danger text-sm" v-show="errors.has('Mobile-' + index)">
                  {{ errors.first('Mobile-' + index) }}
                </span>
              </div>

              <!-- Handle Name Input -->
              <div class="w-full">
                <vs-input
                  :id="'Handle-' + index"
                  class="w-full"
                  v-model="adminUser.handle_name"
                  v-validate="'required'"
                  :name="'Handle-' + index"
                  icon="icon icon-user"
                  disabled
                  icon-pack="feather"
                  placeholder="Please add Handle Name"
                  data-vv-as="Handle Name"
                />
                <span class="text-danger text-sm" v-show="errors.has('Handle-' + index)">
                  {{ errors.first('Handle-' + index) }}
                </span>
              </div>

              <!-- Remove Button -->
              <div class="w-full flex justify-end mt-2">
                <vx-tooltip :text="`Remove`">
                  <vs-button @click="removeEmail(index)" color="danger" type="gradient" icon-pack="feather" icon="icon-trash-2" />
                </vx-tooltip>
              </div>
            </div>
          </div>

          <!-- Add Email Button -->
          <div class="mt-3 mb-3 flex justify-start">
            <vx-tooltip :text="`Add Email`">
              <vs-button @click="addEmail" color="success" type="gradient" icon-pack="feather" icon="icon-plus" />
            </vx-tooltip>
          </div>

          <!-- Action Buttons -->
          <div class="mt-4">
            <div class="w-full px-0 justify-items-center">
              <vs-button class="text-sm py-3 px-5" color="dark" @click.stop="resetForm"> Cancel </vs-button>
              <vs-button
                class="ml-2 vs-con-loading__container text-sm vs-component vs-button vs-button-primary vs-button-filled py-3 px-5"
                id="invite-gurudwara" @click.stop="inviteGuruAdmin">
                Invite
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { dateMixins } from '@/mixins/dateMixins.js'
import organization from '../../store/organization'

export default {
  name: 'adminList',

  mixins: [dateMixins],
  /** Data */
  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    form: { newAdminUsers: [{ email: '', mobile_number: '', handle_name: '' }], organization: '' },
    module_name: 'Organization Admin',
    breadcrumb: [],
    popupActive: false
  }),

  /** Import State */
  computed: {
    ...mapGetters('auth', ['checkPermissionSlug']),
    ...mapState('organization', ['adminRecords', 'adminTotal', 'adminFilteredCount', 'adminListLoading', 'createAdminLoading']),
    /** Page Number Show Logic ( Dynamic ) */
    totalPages() {
      return Math.ceil(this.adminFilteredCount / this.length)
    }
  },

  /** CTA functions */
  methods: {
    /** API Import */
    ...mapActions('organization', {
      get: 'getGurudwaraAdmin',
      inviteAdmin: 'inviteAdmin',
      revokeAccessUser: 'revokeAccessUser',
      getHandleNameByMobile: 'getHandleNameByMobile',
      findValidOrgAdmin: 'findValidOrgAdmin'
    }),

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    resetForm() {
      this.popupActive = false
      this.form = {
        newAdminUsers: [{ email: '', mobile_number: '', handle_name: '' }],
        organization: this.$route.params.id
      }
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** Gurudwara List API */
    getData() {
      this.get({
        // order: this.order,
        organization: this.$route.params.id,
        limit: this.length,
        page: this.page,
        search: this.search
      })
    },

    /*** Invite member */
    inviteMember() {
      if (this.popupActive) {
        this.popupActive = false
      } else {
        this.popupActive = true
      }
    },

    addEmail() {
      this.form.newAdminUsers.push({ email: '', mobile_number: '', handle_name: '' })
    },

    removeEmail(index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete?`,
        accept: () => {
          this.form.newAdminUsers.splice(index, 1) // Remove the email input at the specified index
        },
        acceptText: 'Delete'
      })
    },

    /** Revoke gurudwara admin Confirmation */
    revokeAccess(id, name) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Access Revoke`,
        text: `Are you sure you want to remove access '${name}' this record?`,
        accept: () => this.revokeAccessById(id),
        acceptText: 'Revoke Access'
      })
    },

    /** Revoke gurudwara admin API */
    async revokeAccessById(id) {
      try {
        const { message } = await this.revokeAccessUser({ organizationId: this.$route.params.id, userId: id })
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    },
    /** Invite Admin */
    async inviteGuruAdmin() {
      let valid = true
      for (let i = 0; i < this.form.newAdminUsers.length; i++) {
        const emailValid = await this.$validator.validate(`Email-${i}`)
        const mobileValid = await this.$validator.validate(`Mobile-${i}`)
        const handleValid = await this.$validator.validate(`Handle-${i}`)

        if (!emailValid || !mobileValid || !handleValid) {
          valid = false
        }
      }
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }

      if (!this.form.newAdminUsers.length) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please add at least one email',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        const { message } = await this.inviteAdmin(this.form)
        this.form.newAdminUsers = [{ email: '', mobile_number: '', handle_name: '' }]
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.popupActive = false
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    debouncedOrgAdminCheck(adminUser, index) {
      clearTimeout(this._orgTimer)
      this._orgTimer = setTimeout(() => {
        const mobile = adminUser.mobile_number
        const email = adminUser.email
        this.validOrganizationAdmin(mobile, email, index)
      }, 600)
    },

    async validOrganizationAdmin(mobile, email, index) {
      if (!mobile && !email) {
        this.form.newAdminUsers[index].handle_name = ''
        return
      }

      // If mobile is entered, wait for at least 7 digits (international support)
      if (mobile && String(mobile).length < 7 && !email) return

      try {
        const response = await this.findValidOrgAdmin({ mobile_number: mobile, email, organizationId: this.form.organization })
        if (response.validAdmin) {
          this.form.newAdminUsers[index].email = response.validAdmin.email
          this.form.newAdminUsers[index].mobile_number = response.validAdmin.mobile_number
          this.form.newAdminUsers[index].handle_name = response.validAdmin.handle_name
          this.$vs.notify({
            title: 'Fetch User Details',
            text: response.message,
            color: 'success',
            position: 'top-center',
            time: 5000
          })
        }
      } catch (err) {
        // Silently ignore errors during auto-detection
      }
    },

  },

  /** Watchers */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    adminListLoading() {
      if (this.adminListLoading) {
        this.$vs.loading({
          container: '#admin-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#admin-list > .con-vs-loading')
      }
    },
    createAdminLoading() {
      if (this.createAdminLoading) {
        this.$vs.loading({
          container: '#invite-gurudwara',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#invite-gurudwara > .con-vs-loading')
      }
    },
    /** Page Loading when data retrive ( API Based ) */
    page() {
      this.getData()
    }
  },

  /** On Rendering */
  async mounted() {
    this.form.organization = this.$route.params.id
    this.getData()
    const organizationId = this.$route.params.id

    if (organizationId) {
      await this.$store.dispatch('organization/show', organizationId).then(async (res) => {
        const data = res.data.data
        this.breadcrumb = [
          { title: 'Dashboard', url: '/dashboard' },
          { title: 'Organization', url: '/organization/list' },
          { title: data.name, url: `/organization/${organizationId}/organization-admin-list` },
          { title: 'Organization Admin', active: true }
        ]
      })
    }
  }
}
</script>
<style>
.vs-tooltip {
  z-index: 9999999 !important;
}

.con-vs-dialog {
  z-index: 9999999 !important;
}
</style>
